import { tableNodeStyleEntries } from '@tiptap-pro/extension-convert-kit';

const BLOCK_LAYOUT_PROPERTIES = new Set(['margin-left']);
const TABLE_VIEW_OWNED_PROPERTIES = new Set(['width', 'max-width']);

export function tableContainerStyles(attrs: Record<string, unknown>): Record<string, string> {
  const styles: Record<string, string> = {};

  for (const [attr, entry] of Object.entries(tableNodeStyleEntries)) {
    if (entry.kind !== 'style') {
      continue;
    }

    for (const [property, value] of Object.entries(entry.toStyle(attrs[attr]))) {
      if (TABLE_VIEW_OWNED_PROPERTIES.has(property)) {
        continue;
      }

      const appliesToContainer = BLOCK_LAYOUT_PROPERTIES.has(property) || property.startsWith('--');
      styles[appliesToContainer ? property : `--tt-table-${property}`] = value;
    }
  }

  return styles;
}
